// extracted by css-extract-rspack-plugin
export default {"ToastCard":"AwrQz","ToastMessage":"XnSus","TabIcon":"W52ax","CloseIcon":"kpUMf"};